import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ButtonComponent } from '@cumlaude/shared-components-buttons';
import { ENV_CONFIG, EnvConfiguration } from '@cumlaude/shared-configuration';
import { HistoryService } from '@cumlaude/shared-services';
import { MagisterInstellingSettingsComponent } from './magister-instelling-settings.component';
import { IconComponent } from '@cumlaude/shared-components-icons';

@Component({
	selector: 'app-instelling-toevoegen-page',
	templateUrl: './instelling-toevoegen-page.component.html',
	styleUrl: './instelling-toevoegen-page.component.scss',
	imports: [ButtonComponent, MagisterInstellingSettingsComponent, IconComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstellingToevoegenPageComponent {
	private readonly envConfig = inject<EnvConfiguration>(ENV_CONFIG);
	private readonly historyService = inject(HistoryService);

	somtodayUrl: string;

	constructor() {
		this.somtodayUrl = this.envConfig.somtodayUrl!;
	}

	goBack() {
		this.historyService.back();
	}
}
